// removed by extract-text-webpack-plugin
module.exports = {"card":"card__2I1l2","inner-card":"inner-card__2jFO3","image":"image__W8okn","brand":"brand__1kFiN","model":"model__3fz9O","type":"type__1oy67","price":"price__KyCwj","horizontal-separator":"horizontal-separator__24FiI","opening-rectangle":"opening-rectangle__2Bhu9","status":"status__2wTX6","detail-button":"detail-button__2KbVm","coming-soon":"coming-soon__3CATt","closed":"closed__2Gk-5","active":"active__263gS","closing-soon":"closing-soon__3hczT","time-divider":"time-divider__23vmI","closed-statuses":"closed-statuses__XPcb4"};


//////////////////
// WEBPACK FOOTER
// ./components/raffle/styles/RaffleCard.scss
// module id = GUdp
// module chunks = 1